export function GlobalStyles() {
	return (
		<style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;500;600;700;800;900&display=swap');
        @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@1,600&display=swap');

        :root {
          /* The page background is painted on <html> (root.tsx). Before Tailwind v4 this
             token was a hex inside hsl(), i.e. invalid and dropped everywhere, so
             bg-background never painted anything; keep that behavior. */
          --background: transparent;
          --foreground: hsl(210 40% 98%);
          --card: hsl(222.2 84% 4.9%);
          --card-foreground: hsl(210 40% 98%);
          --popover: hsl(222.2 84% 4.9%);
          --popover-foreground: hsl(210 40% 98%);
          --primary: hsl(217.2 91.2% 59.8%);
          --primary-foreground: hsl(222.2 47.4% 11.2%);
          --secondary: hsl(217.2 32.6% 17.5%);
          --secondary-foreground: hsl(210 40% 98%);
          --muted: hsl(217.2 32.6% 17.5%);
          --muted-foreground: hsl(215 20.2% 65.1%);
          --accent: hsl(217.2 32.6% 17.5%);
          --accent-foreground: hsl(210 40% 98%);
          --destructive: hsl(0 62.8% 30.6%);
          --destructive-foreground: hsl(210 40% 98%);
          --border: hsl(217.2 32.6% 17.5%);
          --input: hsl(217.2 32.6% 17.5%);
          --ring: hsl(224.3 76.3% 48%);
        }

        /* Apply DM Sans to all text */
        html {
          font-family: 'DM Sans', sans-serif;
        }

        /* Apply DM Sans to all headings */
        h1, h2, h3, h4, h5, h6 {
          font-family: 'DM Sans', sans-serif !important;
        }

        /* Apply DM Sans to all button and span elements */
        button, span, p, a, div {
          font-family: 'DM Sans', sans-serif !important;
        }

        /* Updated Toast styling - remove borders and ensure black background */
        [role="toast-container"] {
          position: fixed !important;
          top: 1.5rem !important;
          left: 50% !important;
          transform: translateX(-50%) !important;
          right: auto !important;
          bottom: auto !important;
          gap: 0.75rem !important;
          z-index: 100 !important;
        }

        [role="toast"] {
          background: #000000 !important;
          border: none !important;
          border-radius: 1rem !important;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;
          color: white !important;
          margin-bottom: 0.75rem !important;
          font-family: 'DM Sans', sans-serif !important;
        }

        [role="toast"][data-variant="destructive"] {
          background: #000000 !important;
          border: none !important;
        }

        /* Ensure all buttons use DM Sans */
        button {
          font-family: 'DM Sans', sans-serif !important;
        }

        /* Ensure all inputs use DM Sans */
        input, textarea, select {
          font-family: 'DM Sans', sans-serif !important;
        }

		.home-inter-font,
		.home-inter-font * {
			font-family: 'Inter', sans-serif !important;
		}

	.orbitron {
			font-family: 'Orbitron', sans-serif !important;
		}

		.orbitron-title {
			font-family: 'Orbitron', sans-serif !important;
			font-weight: 900 !important;
		}

		.roboto-mono {
			font-family: 'Roboto Mono', monospace !important;
		}
      `}</style>
	);
}
